export const TIPO_SERVICIO_GARANTIA = 1
export const TIPO_SERVICIO_PRESUPUESTO = 4

// Must match the claves in sill-back configuracion/claves.py
export const CLAVE_CONSENTIMIENTO_POR_TIPO_SERVICIO = {
  [TIPO_SERVICIO_GARANTIA]: 'consentimiento_formateo_garantia',
  [TIPO_SERVICIO_PRESUPUESTO]: 'consentimiento_formateo_presupuesto',
}

export const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',')
  const mime = header.match(/:(.*?);/)[1]
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new Blob([bytes], { type: mime })
}
